import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AlertRuleDeleteModalUI from './AlertRuleDeleteModalUI.js'

class AlertRuleDeleteModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
    }
  }

  render() {
    return (
      <AlertRuleDeleteModalUI
        context={this.props.context}
        project={this.props.project}
        messageList={this.props.messageList}
        alertRuleId={this.props.alertRuleId}
        errorList={this.state.errorList}
        setErrorList={(errorList) => {this.setState({errorList: errorList})}}
        successMsg={this.state.successMsg}
        onCancel={this.props.onCancel}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: null,
      submitted: true
    })

    let context = this.props.context

    RestApiUtils.delete(context,
      `/api/projects/${this.props.project.projectId}/alerts/${this.props.alertRuleId}`,
      this.onSubmitCallback
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.AlertRules(this.props.project.projectId))
      setTimeout(() => {
        this.props.onRefresh()
        this.props.history.push(`/projects/${this.props.project.projectId}/alerts`)
      }, 2000)
    }
  }

}

export default withRouter(AlertRuleDeleteModalSF)
